import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Upload, Button, message, Typography } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

import AssetHelper from '../../helpers/asset';

const { Dragger } = Upload;
const { Title } = Typography;

const ScanReceiptPage = () => {
	const history = useHistory();
	const [uploading, setUploading] = useState(false);
	const [fileList, setFileList] = useState([]);

	const uploadProps = {
		name: 'file',
		multiple: false,
		action: AssetHelper.getScanReceiptUrl(),
		headers: AssetHelper.getHeader(),
		accept: 'image/*,.pdf',
		fileList,
		beforeUpload: (file) => {
			if (file.size > AssetHelper.getMaxSize()) {
				message.error(`${file.name} ${AssetHelper.getMaxSizeMsg()}`);
				return false;
			}
			return true;
		},
		onChange: (info) => {
			const { status } = info.file;

			if (status === 'uploading') {
				setUploading(true);
			}

			if (status === 'done') {
				setUploading(false);
				message.success(`${info.file.name} uploaded successfully. Your receipt is now being processed.`);
				setTimeout(() => {
					history.push('/scan-history');
				}, 1500);
			} else if (status === 'error') {
				setUploading(false);
				message.error(`${info.file.name} upload failed.`);
			}

			setFileList(info.fileList.slice(-1));
		},
		onDrop() {
			setFileList([]);
		}
	};

	return (
		<div style={{ padding: '24px' }}>
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
				<Title level={4} style={{ margin: 0 }}>Scan Receipt</Title>
				<Button onClick={() => history.push('/scan-history')}>
					View Scan History
				</Button>
			</div>
			<div style={{ maxWidth: '600px', margin: '0 auto' }}>
				<Dragger {...uploadProps} disabled={uploading}>
					<p className="ant-upload-drag-icon">
						<InboxOutlined />
					</p>
					<p className="ant-upload-text">Click or drag a receipt image to this area to upload</p>
					<p className="ant-upload-hint">
						Supports single image or PDF file. Maximum file size: 5MB.
						Your receipt will be processed automatically by AI.
					</p>
				</Dragger>
			</div>
		</div>
	);
};

export default ScanReceiptPage;
